export default __webpack_public_path__ + "static/cenetec_salud-19c9b3ec254b7671c18c53126c91a912.webp";